module.exports = __webpack_public_path__ + "static/favicon-008b1e82f4cbeedd627c72c233ffb935.ico";